export default __webpack_public_path__ + "2b0316d4fb0e506e8a3b044d41cc6290.png";